const theme = {
    colors: {
        blue:'#3853A3',
        yellow:'#FFA800',
        textgreyBlue:'#7E94AB',
        textBlue:'#3853A3'
    },
}

export default theme